import { safeRedirect } from '@ordermentum/ui-shared/helpers/urls';

export const changeWindowLocation = (url: string) => {
  window.location.href = safeRedirect(url);
};
